import { Injectable } from '@angular/core';
import {
  HubConnection,
  HubConnectionBuilder,
  HubConnectionState,
  LogLevel,
} from '@microsoft/signalr';
import { environment } from '../../../../environments/environment.prod';

import { AuthService } from '../auth/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SignalRService {
  private hubConnection: HubConnection | null = null;
  private hubUrl: string = '';
  private destroy$ = new Subject<void>();

  constructor(private authService: AuthService) {
    this.authService.onLogout$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.disconnect();
    });
  }

  // Connect to the SignalR hub
  connect(url: string) {
    if (
      this.hubConnection &&
      this.hubConnection.state === HubConnectionState.Connected
    ) {
      console.log('Already connected to the hub');
      return;
    }
    this.hubUrl = url; // Set the hub URL
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(this.hubUrl, {
        logger: environment.production ? LogLevel.Critical : LogLevel.Trace,
      })
      .withAutomaticReconnect() // Automatically reconnect
      .build();

    // Start the connection and handle errors
    // this.startConnection().catch((err) =>
    //   console.error('Error while starting SignalR connection:', err)
    // );
  }

  // Start the SignalR connection
  private async startConnection() {
    if (this.hubConnection) {
      try {
        await this.hubConnection.start(); // Start the connection
        console.log('SignalR connection established successfully.');
      } catch (error) {
        console.error('Error establishing SignalR connection:', error);
        setTimeout(() => this.startConnection(), 5000); // Retry connection after 5 seconds
      }
    }
  }

  // Disconnect from the SignalR hub
  disconnect() {
    if (this.hubConnection) {
      this.hubConnection
        .stop()
        .then(() => {
          console.log('SignalR connection stopped.');
          this.hubConnection = null; // Clear the connection
        })
        .catch((err) =>
          console.error('Error while stopping SignalR connection:', err)
        );
    }
  }

  // Listen for messages from the hub
  on(eventName: string, callback: (...args: any[]) => void) {
    if (this.hubConnection) {
      this.hubConnection.on(eventName, callback);
    }
  }

  // Remove event listener
  off(eventName: string) {
    if (this.hubConnection) {
      this.hubConnection.off(eventName);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
